export function formatDate(timestamp) {
  if (!timestamp) return '-';
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleDateString();
}

export function formatDateTime(timestamp) {
  if (!timestamp) return '-';
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString();
}

export function formatCurrency(value) {
  const num = typeof value === 'number' ? value : Number(value) || 0;
  return `$${num.toFixed(2)}`;
}

export function formatCompactNumber(value) {
  const num = typeof value === 'number' ? value : Number(value) || 0;
  return new Intl.NumberFormat('en-US', { notation: 'compact' }).format(num);
}

// Seeds a <input type="datetime-local"> from a Firestore timestamp (or its {_seconds} JSON shape).
export function toDatetimeLocalValue(timestamp) {
  if (!timestamp) return '';
  const date = timestamp._seconds
    ? new Date(timestamp._seconds * 1000)
    : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
